function Months()
{

}

Months.prototype.names = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December'
];

/**
 * @param {number} month
 * @returns {string}
 */
Months.prototype.monthToString = function (month)
{
	return Months.prototype.names[(month - 1)];
};

/**
 * @param {number} month
 * @returns {string}
 */
Months.prototype.dateMonthToString = function (month)
{
	return Months.prototype.names[month];
};

/**
 * @returns {Object}
 */
Months.prototype.getMonthsObject = function ()
{
	var res = {};

	for (var i = 0; i < Months.prototype.names.length; i++) {
		res[i] = Months.prototype.names[i];
	}

	return res;
};
